<template>
  <div>
    <div style="float: left">
      <el-upload class="upload-file"
                 action=""
                 :disabled="disabled"
                 :before-upload="onFile"
                 multiple>
        <el-button size="small"
                   :disabled="disabled"
                   type="primary">
          {{(v.fileid || '').split('/')[0] === 'tmp' ? 'New file: ' : '' }}
          {{v.filename ? v.filename : '打开文件'}}
        </el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
import LibProductItem from '../../../minxin/ProductItem';
import base64 from 'base64-arraybuffer'
import request from '../../../api/request';

export default {
  name: 'ProductItemTypeFile',
  mixins: [LibProductItem],
  props: {
    value: Object
  },
  computed: {
    v() {
      return this.dd || {}
    }
  },
  methods: {
    onFile(file) {
      let filename = file.name
      let reader = new FileReader()
      reader.onloadend = function (evt) {
        if (evt.target.readyState === FileReader.DONE) {
          request.product.post('file_upload', {
            filename: filename,
            content: base64.encode(evt.target.result)
          }).then(r => {
            this.dd = {
              filename: filename,
              fileid: r.data.fileid
            }
          }).catch(() => {
            this.$message.error('upload failed');
          })
        }
      }.bind(this)
      reader.readAsArrayBuffer(file, 'utf-8')
      return false
    }
  }
}
</script>